const Companies = [
  {
    path: '/companies',
    name: 'Companies',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Empresas',
      // roles: [Director, Manager, Supervisor],
    },
    // component: () => import(`@/pages/company/Agenda.vue`)
  },
  {
    path: '/create_company',
    name: 'CreateCompany',
    meta: { 
      auth: true,
      // needs_company: true,
      tab_name: 'Nova Empresa',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/company/CreateCompany.vue`)
  },
  {
    path: '/company/:id',
    name: 'ShowCompany',
    meta: { 
      auth: true,
      needs_company: true,
      tab_name: 'Editando empresa',
      // roles: [Director, Manager, Supervisor],
    },
    // component: () => import(`@/pages/company/ShowEvent.vue`)
  },
  {
    path: '/exclusion_confirm',
    name: 'ExclusionConfirm',
    meta: { 
      auth: true,
      needs_company: false,
      tab_name: 'Confirmação de exclusão',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/components/company/CompanyExclusionConfirm.vue`)
  },
  
]

export default Companies
